import * as React from 'react';
import ReactHtmlParser from 'html-react-parser';

require('../css/checkbox.css');

interface Props {
  checked?: boolean;
  id: string;
  label: string;
  name?: string;

  // Adding a property to add external css class. 
  checkboxClassName?: string;
  externalDivClass?: string;
  labelClassName?: string;

  wrapperProps?: React.DetailedHTMLProps<
    React.HtmlHTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >;
  onChange?(checked: boolean): void;
  onChangeEvent?(e: React.ChangeEvent<HTMLInputElement>): void;
}

class Checkbox extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  change = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (this.props.onChange) {
      this.props.onChange(e.currentTarget.checked);
    }
    if (this.props.onChangeEvent) {
      this.props.onChangeEvent(e);
    }
  };

  render() {
    // Check if external css properties comes from parent
    let checkboxUserClass = this.props.checkboxClassName === null ? '' : this.props.checkboxClassName;
    let checkboxlabelClass = this.props.labelClassName === null ? '' : this.props.labelClassName;
    let checkboxDivClass = this.props.externalDivClass === null ? '' : this.props.externalDivClass;

    return (
      <div className={checkboxDivClass}>
      <span {...this.props.wrapperProps}>
        <input
          type="checkbox"
          name={this.props.name}
          className={`filled-in ${checkboxUserClass}`}
          id={this.props.id}
          checked={this.props.checked}
          onChange={this.change}
        />
        <label htmlFor={this.props.id} className={checkboxlabelClass}>
          {ReactHtmlParser(this.props.label)}
        </label>
      </span>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/Components/Checkbox.tsx